var _a, _b, _c;
import { ethers } from 'ethers';
export var orderVaultContracts = [
    { address: '0x82aFd2590814a7Ce3d7ea6b63F80481F8b227bA9', chainId: 421613 },
    { address: '0x31eF83a530Fde1B38EE9A18093A333D8Bbbc40D5', chainId: 42161 },
];
export var exchangeRouterContracts = [
    { address: '0xdB7421cd7E92414029f16d45D8A15c2904052dDf', chainId: 421613 },
    { address: '0x3B070aA6847bd0fB56eFAdB351f49BBb7619dbc2', chainId: 42161 },
];
export var syntheticsReaderContracts = [
    { address: '0x254feb5D92d01013bb6a975f2971872df622e6E7', chainId: 421613 },
    { address: '0x38d91ED96283d62182Fc6d990C24097A918a4d9b', chainId: 42161 },
];
var AddressZero = ethers.constants.AddressZero;
export var NATIVE_TOKEN_ADDRESS = '0x0000000000000000000000000000000000000000';
export var BCS_MAINNET = 56;
export var BCS_TESTNET = 97;
export var ETH_MAINNET = 1;
export var ETH_GOERLI = 5;
export var ETH_SEPOLIA = 11155111;
export var AVALANCHE = 43114;
export var AVALANCHE_FUJI = 43113;
export var ARBITRUM = 42161;
export var ARBITRUM_GOERLI = 421613;
export var FEES_HIGH_BPS = 50;
export var MAX_EXCEEDING_THRESHOLD = '1000000000';
export var MIN_EXCEEDING_THRESHOLD = '0.01';
export var TRIGGER_PREFIX_ABOVE = '>';
export var TRIGGER_PREFIX_BELOW = '<';
export var CHAIN_IDS = [ARBITRUM, ARBITRUM_GOERLI];
export var USD_DECIMALS = 30;
export var HIGH_EXECUTION_FEES_MAP = (_a = {},
    _a[ARBITRUM] = 3,
    _a[ARBITRUM_GOERLI] = 3,
    _a[AVALANCHE_FUJI] = 3,
    _a);
export var contracts = (_b = {},
    _b[ARBITRUM_GOERLI] = {
        // arbitrum testnet
        Vault: AddressZero,
        Router: AddressZero,
        VaultReader: AddressZero,
        Reader: AddressZero,
        GlpManager: AddressZero,
        RewardRouter: AddressZero,
        RewardReader: AddressZero,
        GlpRewardRouter: AddressZero,
        NATIVE_TOKEN: '0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3',
        GLP: AddressZero,
        GMX: AddressZero,
        ES_GMX: AddressZero,
        BN_GMX: AddressZero,
        USDG: AddressZero,
        ES_GMX_IOU: AddressZero,
        StakedGmxTracker: AddressZero,
        BonusGmxTracker: AddressZero,
        FeeGmxTracker: AddressZero,
        StakedGlpTracker: AddressZero,
        FeeGlpTracker: AddressZero,
        StakedGmxDistributor: AddressZero,
        StakedGlpDistributor: AddressZero,
        GmxVester: AddressZero,
        GlpVester: AddressZero,
        OrderBook: AddressZero,
        OrderExecutor: AddressZero,
        OrderBookReader: AddressZero,
        PositionRouter: AddressZero,
        PositionManager: AddressZero,
        TraderJoeGmxAvaxPool: AddressZero,
        ReferralStorage: '0x995E905E471D53B7c5d0dbf6406860Cb3C029e95',
        ReferralReader: AddressZero,
        // Synthetics
        DataStore: '0xbA2314b0f71ebC705aeEBeA672cc3bcEc510D03b',
        EventEmitter: '0x2fbE45fCb58B7106CF0a3Be9225D5Ed5A1004cc4',
        ExchangeRouter: '0xdB7421cd7E92414029f16d45D8A15c2904052dDf',
        DepositVault: '0x838a9bdf8736eD522A60F5f715e4F3FC2BC91A08',
        WithdrawalVault: '0xaAac001C2a2727Ff2d484C4Ad7d2079C7094e7Ef',
        OrderVault: '0x82aFd2590814a7Ce3d7ea6b63F80481F8b227bA9',
        SyntheticsReader: '0x254feb5D92d01013bb6a975f2971872df622e6E7',
        SyntheticsRouter: '0xfB8e176df6B5bB7132889C012550bEaa6288014d',
        Timelock: AddressZero,
        Multicall: '0x6d85594c9BD6b0833bC85AE62B360654A1e52D70',
    },
    _b[ARBITRUM] = {
        // arbitrum mainnet
        Vault: '0x489ee077994B6658eAfA855C308275EAd8097C4A',
        Router: '0xaBBc5F99639c9B6bCb58544ddf04EFA6802F4064',
        VaultReader: '0xfebB9f4CAC4cD523598fE1C5771181440143F24A',
        Reader: '0x2b43c90D1B727cEe1Df34925bcd5Ace52Ec37694',
        GlpManager: '0x3963FfC9dff443c2A94f21b129D429891E32ec18',
        RewardRouter: '0xA906F338CB21815cBc4Bc87ace9e68c87eF8d8F1',
        GlpRewardRouter: '0xB95DB5B167D75e6d04227CfFFA61069348d271F5',
        RewardReader: '0x8BFb8e82Ee4569aee78D03235ff465Bd436D40E0',
        NATIVE_TOKEN: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
        GLP: '0x4277f8F2c384827B5273592FF7CeBd9f2C1ac258',
        GMX: '0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a',
        ES_GMX: '0xf42Ae1D54fd613C9bb14810b0588FaAa09a426cA',
        BN_GMX: '0x35247165119B69A40edD5304969560D0ef486921',
        USDG: '0x45096e7aA921f27590f8F19e457794EB09678141',
        ES_GMX_IOU: '0x6260101218eC4cCfFF1b778936C6f2400f95A954',
        StakedGmxTracker: '0x908C4D94D34924765f1eDc22A1DD098397c59dD4',
        BonusGmxTracker: '0x4d268a7d4C16ceB5a606c173Bd974984343fea13',
        FeeGmxTracker: '0xd2D1162512F927a7e282Ef43a362659E4F2a728F',
        StakedGlpTracker: '0x1aDDD80E6039594eE970E5872D247bf0414C8903',
        FeeGlpTracker: '0x4e971a87900b931fF39d1Aad67697F49835400b6',
        StakedGmxDistributor: '0x23208B91A98c7C1CD9FE63085BFf68311494F193',
        StakedGlpDistributor: '0x60519b48ec4183a61ca2B8e37869E675FD203b34',
        GmxVester: '0x199070DDfd1CFb69173aa2F7e20906F26B363004',
        GlpVester: '0xA75287d2f8b217273E7FCD7E86eF07D33972042E',
        OrderBook: '0x09f77E8A13De9a35a7231028187e9fD5DB8a2ACB',
        OrderExecutor: '0x7257ac5D0a0aaC04AA7bA2AC0A6Eb742E332c3fB',
        OrderBookReader: '0xa27C20A7CF0e1C68C0460706bB674f98F362Bc21',
        PositionRouter: '0xb87a436B93fFE9D75c5cFA7bAcFff96430b09868',
        PositionManager: '0x75E42e6f01baf1D6022bEa862A28774a9f8a4A0C',
        //UniswapGmxEthPool: '0x80A9ae39310abf666A87C743d6ebBD0E8C42158E',
        ReferralStorage: '0xe6fab3f0c7199b0d34d7fbe83394fc0e0d06e99d',
        ReferralReader: '0x8Aa382760BCdCe8644C33e6C2D52f6304A76F5c8',
        // Synthetics
        DataStore: '0xFD70de6b91282D8017aA4E741e9Ae325CAb992d8',
        EventEmitter: '0xC8ee91A54287DB53897056e12D9819156D3822Fb',
        ExchangeRouter: '0x3B070aA6847bd0fB56eFAdB351f49BBb7619dbc2',
        DepositVault: '0xF89e77e8Dc11691C9e8757e84aaFbCD8A67d7A55',
        WithdrawalVault: '0x0628D46b5D145f183AdB6Ef1f2c97eD1C4701C55',
        OrderVault: '0x31eF83a530Fde1B38EE9A18093A333D8Bbbc40D5',
        SyntheticsReader: '0x38d91ED96283d62182Fc6d990C24097A918a4d9b',
        SyntheticsRouter: '0x7452c558d45f8afC8c83dAe62C3f8A5BE19c71f6',
        Timelock: '0xaa50bD556CE0Fe61D4A57718BA43177a3aB6A597',
        Multicall: '0xcA11bde05977b3631167028862bE2a173976CA11',
    },
    _b);
export var BASIS_POINTS_DIVISOR = 10000;
export var MAX_LEVERAGE = 100 * BASIS_POINTS_DIVISOR;
export var MAX_ALLOWED_LEVERAGE = 50 * BASIS_POINTS_DIVISOR;
export var TOKENS = (_c = {},
    _c[ETH_MAINNET] = [],
    _c[ETH_GOERLI] = [],
    _c[ETH_SEPOLIA] = [],
    _c[ARBITRUM] = [
        {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
            value: ethers.constants.AddressZero,
            isNative: true,
            isShortable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
            isV1Available: true,
        },
        {
            name: 'Wrapped Ethereum',
            symbol: 'WETH',
            decimals: 18,
            value: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
            isWrapped: true,
            baseSymbol: 'ETH',
            logoURI: 'https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
            isV1Available: true,
        },
        {
            name: 'Bitcoin (WBTC)',
            symbol: 'BTC',
            decimals: 8,
            value: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
            isShortable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/26115/thumb/btcb.png?1655921693',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/wrapped-bitcoin',
            explorerUrl: 'https://arbiscan.io/address/0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
            isV1Available: true,
        },
        {
            name: 'Arbitrum',
            symbol: 'ARB',
            decimals: 18,
            priceDecimals: 3,
            value: '0x912CE59144191C1204E64559FE8253a0e49E6548',
            logoURI: 'https://assets.coingecko.com/coins/images/16547/small/photo_2023-03-29_21.47.00.jpeg?1680097630',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/arbitrum',
            explorerUrl: 'https://arbiscan.io/token/0x912ce59144191c1204e64559fe8253a0e49e6548',
        },
        {
            name: 'Wrapped SOL (Wormhole)',
            symbol: 'SOL',
            decimals: 9,
            value: '0x2bcC6D6CdBbDC0a4071e48bb3B969b06B3330c07',
            logoURI: 'https://assets.coingecko.com/coins/images/4128/small/solana.png?1640133422',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/solana',
            explorerUrl: 'https://arbiscan.io/token/0x2bCc6D6CdBbDC0a4071e48bb3B969b06B3330c07',
        },
        {
            name: 'Chainlink',
            symbol: 'LINK',
            decimals: 18,
            priceDecimals: 3,
            value: '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4',
            isStable: false,
            isShortable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/chainlink',
            explorerUrl: 'https://arbiscan.io/token/0xf97f4df75117a78c1a5a0dbb814af92458539fb4',
            isV1Available: true,
        },
        {
            name: 'Uniswap',
            symbol: 'UNI',
            decimals: 18,
            priceDecimals: 3,
            value: '0xFa7F8980b0f1E64A2062791cc3b0871572f1F7f0',
            isStable: false,
            isShortable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/12504/thumb/uniswap-uni.png?1600306604',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/uniswap',
            explorerUrl: 'https://arbiscan.io/token/0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0',
            isV1Available: true,
        },
        {
            name: 'Bridged USDC (USDC.e)',
            symbol: 'USDC.e',
            decimals: 6,
            value: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
            isStable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/usd-coin',
            explorerUrl: 'https://arbiscan.io/token/0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
            isV1Available: true,
        },
        {
            name: 'USD Coin',
            symbol: 'USDC',
            decimals: 6,
            value: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
            isStable: true,
            isV1Available: true,
            logoURI: 'https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/usd-coin',
            explorerUrl: 'https://arbiscan.io/address/0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
        },
        {
            name: 'Tether',
            symbol: 'USDT',
            decimals: 6,
            value: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
            isStable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/325/thumb/Tether-logo.png?1598003707',
            explorerUrl: 'https://arbiscan.io/value/0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/tether',
            isV1Available: true,
        },
        {
            name: 'Dai',
            symbol: 'DAI',
            decimals: 18,
            value: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
            isStable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/9956/thumb/4943.png?1636636734',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/dai',
            explorerUrl: 'https://arbiscan.io/token/0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
            isV1Available: true,
        },
        {
            name: 'Frax',
            symbol: 'FRAX',
            decimals: 18,
            value: '0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F',
            isStable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/13422/small/frax_logo.png?1608476506',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/frax',
            explorerUrl: 'https://arbiscan.io/token/0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F',
            isV1Available: true,
        },
        {
            name: 'Magic Internet Money',
            symbol: 'MIM',
            decimals: 18,
            value: '0xFEa7a6a0B346362BF88A9e4A88416B77a57D6c2A',
            isStable: true,
            isTempHidden: true,
            logoURI: 'https://assets.coingecko.com/coins/images/16786/small/mimlogopng.png',
            isV1Available: true,
        },
        {
            name: 'Bitcoin',
            symbol: 'BTC',
            value: '0x47904963fc8b2340414262125aF798B9655E58Cd',
            isSynthetic: true,
            decimals: 8,
            logoURI: 'https://assets.coingecko.com/coins/images/1/small/bitcoin.png?1547033579',
            //TODO: remove explorerUrl in future
            explorerUrl: 'https://arbiscan.io/address/0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/bitcoin',
        },
        {
            name: 'Dogecoin',
            symbol: 'DOGE',
            decimals: 8,
            priceDecimals: 4,
            value: '0xC4da4c24fd591125c3F47b340b6f4f76111883d8',
            isSynthetic: true,
            logoURI: 'https://assets.coingecko.com/coins/images/5/small/dogecoin.png?1547792256',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/dogecoin',
        },
        {
            name: 'Litecoin',
            symbol: 'LTC',
            decimals: 8,
            value: '0xB46A094Bc4B0adBD801E14b9DB95e05E28962764',
            isSynthetic: true,
            logoURI: 'https://assets.coingecko.com/coins/images/2/small/litecoin.png?1547033580',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/litecoin',
        },
        {
            name: 'XRP',
            symbol: 'XRP',
            decimals: 6,
            priceDecimals: 4,
            value: '0xc14e065b0067dE91534e032868f5Ac6ecf2c6868',
            logoURI: 'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png?1605778731',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/xrp',
            isSynthetic: true,
        },
        {
            name: 'GMX',
            symbol: 'GMX',
            value: AddressZero,
            decimals: 18,
            isPlatformToken: true,
            logoURI: 'https://assets.coingecko.com/coins/images/18323/small/arbit.png?1631532468',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/gmx',
            explorerUrl: 'https://arbiscan.io/address/0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a',
        },
        {
            name: 'Escrowed GMX',
            symbol: 'esGMX',
            value: AddressZero,
            decimals: 18,
            isPlatformToken: true,
        },
        {
            name: 'GMX LP',
            symbol: 'GLP',
            value: AddressZero,
            decimals: 18,
            logoURI: 'https://github.com/gmx-io/gmx-assets/blob/main/GMX-Assets/PNG/GLP_LOGO%20ONLY.png?raw=true',
            reservesUrl: 'https://portfolio.nansen.ai/dashboard/gmx?chain=ARBITRUM',
            isPlatformToken: true,
        },
    ],
    _c[ARBITRUM_GOERLI] = [
        {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
            value: ethers.constants.AddressZero,
            isNative: true,
            isShortable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
        },
        {
            name: 'Wrapped Ethereum',
            symbol: 'WETH',
            decimals: 18,
            value: '0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3',
            isWrapped: true,
            baseSymbol: 'ETH',
            logoURI: 'https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
            explorerUrl: 'https://goerli.arbiscan.io/address/0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3',
        },
        {
            name: 'Bitcoin',
            symbol: 'BTC',
            decimals: 8,
            value: '0xCcF73F4Dcbbb573296BFA656b754Fe94BB957d62',
            isShortable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/7598/thumb/wrapped_bitcoin_wbtc.png?1548822744',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/bitcoin',
            explorerUrl: 'https://goerli.arbiscan.io/address/0xCcF73F4Dcbbb573296BFA656b754Fe94BB957d62',
        },
        {
            name: 'USD Coin',
            symbol: 'USDC',
            decimals: 6,
            value: '0x04FC936a15352a1b15b3B9c56EA002051e3DB3e5',
            isStable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/usd-coin',
            explorerUrl: 'https://goerli.arbiscan.io/address/0x04FC936a15352a1b15b3B9c56EA002051e3DB3e5',
        },
        {
            name: 'Tether',
            symbol: 'USDT',
            decimals: 6,
            value: '0xBFcBcdCbcc1b765843dCe4DF044B92FE68182a62',
            isStable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/tether',
            explorerUrl: 'https://goerli.arbiscan.io/address/0xBFcBcdCbcc1b765843dCe4DF044B92FE68182a62',
        },
        {
            name: 'Dai',
            symbol: 'DAI',
            value: '0x7b7c6c49fA99b37270077FBFA398748c27046984',
            decimals: 18,
            isStable: true,
            logoURI: 'https://assets.coingecko.com/coins/images/9956/thumb/4943.png?1636636734',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/dai',
            explorerUrl: 'https://goerli.arbiscan.io/address/0x7b7c6c49fA99b37270077FBFA398748c27046984',
        },
        {
            name: 'Solana',
            symbol: 'SOL',
            decimals: 18,
            value: '0x9A98a11279FaeB0fF695dFEC3C4B8a29138d0a2f',
            isSynthetic: true,
            logoURI: 'https://assets.coingecko.com/coins/images/4128/small/solana.png?1640133422',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/solana',
        },
        {
            name: 'Test token',
            symbol: 'TEST',
            decimals: 18,
            value: '0x13C52ccB49fE3228356D0C355641961646A0D9B2',
            isSynthetic: true,
            coingeckoUrl: 'https://www.coingecko.com/en/coins/tether',
        },
        {
            name: 'BNB',
            symbol: 'BNB',
            isSynthetic: true,
            decimals: 18,
            value: '0xa076E6db62f61bd1A4fC283F84739D2b0c80e2a3',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/binancecoin',
        },
        {
            name: 'Cardano',
            symbol: 'ADA',
            decimals: 18,
            priceDecimals: 4,
            value: '0x5F8a8f06da2848f846A2b5e3e42A4A2eEC5f337B',
            isSynthetic: true,
            coingeckoUrl: 'https://www.coingecko.com/en/coins/cardano',
        },
        {
            name: 'TRON',
            symbol: 'TRX',
            decimals: 18,
            priceDecimals: 4,
            value: '0x7a9Ba06548D0499f6Debf97809CC351c1e85795D',
            isSynthetic: true,
            coingeckoUrl: 'https://www.coingecko.com/en/coins/tron',
        },
        {
            name: 'Polygon',
            symbol: 'MATIC',
            decimals: 18,
            priceDecimals: 4,
            value: '0xd98D28787F5598749331052f952196428F61e3aD',
            isSynthetic: true,
            coingeckoUrl: 'https://www.coingecko.com/en/coins/polygon',
        },
        {
            name: 'Polkadot',
            symbol: 'DOT',
            decimals: 18,
            value: '0x7361D58cBc6495B6419397dFd5ebE2e2017F23E9',
            isSynthetic: true,
            coingeckoUrl: 'https://www.coingecko.com/en/coins/polkadot',
        },
        {
            name: 'Uniswap',
            symbol: 'UNI',
            decimals: 18,
            priceDecimals: 3,
            value: '0x6DEbb9cC48819941F797a2F0c63f9168C19fD057',
            isSynthetic: true,
            coingeckoUrl: 'https://www.coingecko.com/en/coins/uniswap',
        },
        {
            name: 'Dogecoin',
            symbol: 'DOGE',
            isSynthetic: true,
            isShortable: true,
            decimals: 8,
            priceDecimals: 4,
            value: '0x3e2fA75b78edF836299127FBAA776304B4712972',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/dogecoin',
        },
        {
            name: 'Chainlink',
            symbol: 'LINK',
            decimals: 18,
            priceDecimals: 3,
            value: '0x55602A94239a7926D92da5C53Fb96E80372382aa',
            isSynthetic: true,
            coingeckoUrl: 'https://www.coingecko.com/en/coins/chainlink',
        },
        {
            name: 'XRP',
            symbol: 'XRP',
            decimals: 6,
            priceDecimals: 4,
            value: '0xF1C2093383453831e8c90ecf809691123116dAaC',
            isSynthetic: true,
            logoURI: 'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png?1605778731',
            coingeckoUrl: 'https://www.coingecko.com/en/coins/xrp',
        },
    ],
    _c);
